// this class is used to detect when an async immersive reader request is cancelled by the user instead of errored.
export class CancelImmersiveReaderRequest { }
